import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name mic-audio-lines
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgM3YyLjM0MSIgLz4KICA8cGF0aCBkPSJNMTIgMTd2NCIgLz4KICA8cGF0aCBkPSJNMTQgNXYuMzQxIiAvPgogIDxwYXRoIGQ9Ik0xOCA1djEzIiAvPgogIDxwYXRoIGQ9Ik0yIDEwdjMiIC8+CiAgPHBhdGggZD0iTTIyIDEwdjMiIC8+CiAgPHBhdGggZD0iTTYgNnYxMSIgLz4KICA8cGF0aCBkPSJNOSAyMWg2IiAvPgogIDxyZWN0IHdpZHRoPSI0IiBoZWlnaHQ9IjgiIHg9IjEwIiB5PSI5IiByeD0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/mic-audio-lines
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const MicAudioLines: IconNode = [
  ['path', { d: 'M10 3v2.341' }],
  ['path', { d: 'M12 17v4' }],
  ['path', { d: 'M14 5v.341' }],
  ['path', { d: 'M18 5v13' }],
  ['path', { d: 'M2 10v3' }],
  ['path', { d: 'M22 10v3' }],
  ['path', { d: 'M6 6v11' }],
  ['path', { d: 'M9 21h6' }],
  ['rect', { width: '4', height: '8', x: '10', y: '9', rx: '2' }],
];

export default MicAudioLines;
